import React from "react";
import { Box, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";

function UnderConstructionPage() {
  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        marginBottom: 3,
        padding: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "50vh",
      }}
    >
      {/* Construction Icon */}
      <ConstructionIcon
        sx={{
          fontSize: "80px",
          color: "#ffa726",
          marginBottom: 2,
        }}
      />

      {/* Page Title */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          marginBottom: 1,
          color: "#333",
        }}
      >
        این صفحه در حال ساخت است
      </Typography>

      {/* Subtext */}
      <Typography
        variant="body1"
        sx={{
          color: "#555",
          marginBottom: 3,
        }}
      >
        ما در حال کار بر روی این صفحه هستیم. لطفاً بعداً دوباره سر بزنید.
      </Typography>
    </Box>
  );
}

export default UnderConstructionPage;
